import { IAuthorization } from "./authorization";
import { ICertificate } from "./certificate";
import { IEidasInformation } from "./eidasInformation";
import { ISRB } from "./srb";
import { IRequestFeedback } from "./requestFeedback";

export interface ICrewMember {
    guid: string;
    cid: string;
    lastUpdated: string;
    idDataSets: IIDDataSet[];
    certificates: ICertificate[];
    authorizations: IAuthorization[];
    serviceRecordBooks: ISRB[];
    requestFeedbacks: IRequestFeedback[];
    ecdbAcknowledged: boolean;
    qrBase64: string;
}

export interface IIDDataSet {
    guid: string;
    firstName: string;
    nonLatinFirstName: string;
    lastName: string;
    nonLatinLastName: string;
    dateOfBirth: string;
    placeOfBirth: string;
    nonLatinPlaceOfBirth: string;
    added: string;
    lastUpdated: string;
    crewMemberGuid: string;
    cid: string;
    email: string;
    zipCode: string;
    street: string;
    city: string;
    country: number;
    eidasInformation: IEidasInformation[];
    nationality: number;
    issuingAuthority: string;
    imageBase64: string;
    stateOfBirth: number;
}

export const newIDDataSetInit: IIDDataSet = {
    guid: "",
    firstName: "",
    nonLatinFirstName: "",
    lastName: "",
    nonLatinLastName: "",
    dateOfBirth: "",
    placeOfBirth: "",
    nonLatinPlaceOfBirth: "",
    added: "",
    lastUpdated: "",
    crewMemberGuid: "",
    cid: "",
    email: "",
    zipCode: "",
    street: "",
    city: "",
    country: 9,
    eidasInformation: [],
    nationality: -1,
    issuingAuthority: "",
    imageBase64: "",
    stateOfBirth: -1,
};

export interface IIDDataSetFilter {
    cid: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    placeOfBirth: string;
    page: number;
    examinationOrganization: string;
    dateOfReceiptFrom: string;
    dateOfReceiptTo: string;
    dateOfIssueFrom: string;
    dateOfIssueTo: string;
    column: string;
    descDirection: boolean;
    quickSearch?: string;
    applicationCategoryNewIssue: boolean;
    applicationCategoryAfter: boolean;
    applicationCategoryBefore: boolean;
    currentLanguage: string;
}

export const idDataSetsFilterInit: IIDDataSetFilter = {
    cid: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    placeOfBirth: "",
    page: 0,
    examinationOrganization: "",
    dateOfReceiptFrom: "",
    dateOfReceiptTo: "",
    dateOfIssueFrom: "",
    dateOfIssueTo: "",
    column: "qualificationID",
    descDirection: true,
    applicationCategoryNewIssue: false,
    applicationCategoryAfter: false,
    applicationCategoryBefore: false,
    currentLanguage: "",
    quickSearch: "",
};

export const getLatinNonLatinCombined = (nonlatin: string, latin: string) => {
    if (!!nonlatin) return nonlatin + " (" + latin + ")";
    else return latin;
};

export const getIDDataSetDisplayName = (idDataSet: IIDDataSet) => {
    if (!!idDataSet.nonLatinFirstName && !!idDataSet.nonLatinLastName) {
        return `${idDataSet.nonLatinFirstName} ${idDataSet.nonLatinLastName} (${idDataSet.firstName} ${idDataSet.lastName})`;
    } else if (!!idDataSet.nonLatinFirstName) {
        return `${idDataSet.nonLatinFirstName} ${idDataSet.lastName} (${idDataSet.firstName} ${idDataSet.lastName})`;
    } else if (!!idDataSet.nonLatinLastName) {
        return `${idDataSet.firstName} ${idDataSet.nonLatinLastName} (${idDataSet.firstName} ${idDataSet.lastName})`;
    } else return idDataSet.firstName + " " + idDataSet.lastName;
};

export interface IEcdbIdentityResponse {
    ecdbOffline: boolean;
    offlineNcdbs: string[];
    dataSets: IIDDataSet[];
    current: string[];
}

export const ecdbIdentityResponseInit: IEcdbIdentityResponse = {
    ecdbOffline: true,
    offlineNcdbs: [],
    dataSets: [],
    current: [],
};
